import { Link } from 'react-router-dom';
import type { ComicListItem } from '@storychain/shared';

interface ComicCardProps {
  comic: ComicListItem;
}

export const ComicCard: React.FC<ComicCardProps> = ({ comic }) => {
  const cover = comic.coverImageMediumUrl || comic.coverImageUrl;
  const authorNames = comic.authors.map((a) => a.displayName).join(', ');

  return (
    <Link
      to={`/comic/s/${comic.shareCode}`}
      className="group bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-md transition flex flex-col"
    >
      <div className="aspect-[3/4] bg-gray-100 overflow-hidden">
        {cover ? (
          <img
            src={cover}
            alt={comic.title}
            loading="lazy"
            className="w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-300"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-4xl">📖</div>
        )}
      </div>
      <div className="p-3 flex-1 flex flex-col">
        <h3 className="font-semibold text-gray-900 line-clamp-2 mb-1">{comic.title}</h3>
        {authorNames && (
          <p className="text-xs text-gray-500 line-clamp-1 mb-2">by {authorNames}</p>
        )}
        <div className="mt-auto flex items-center gap-2 text-xs text-gray-500">
          <span className="capitalize px-2 py-0.5 bg-gray-100 rounded-full">{comic.theme}</span>
          {(comic.reactionCount || 0) > 0 ? (
            <span className="tabular-nums">🎭 {comic.reactionCount}</span>
          ) : (
            <span className="text-gray-400">👁 {comic.views}</span>
          )}
        </div>
      </div>
    </Link>
  );
};
